export const ADDRESS_COMPONENT_FIELD_IDS = [
    'current_address_line1',
    'current_address_city',
    'current_address_state',
    'current_address_zip',
] as const

export function formatAddressDisplay(answers: Record<string, unknown>): string {
    const line1 = String(answers.current_address_line1 ?? '').trim()
    const city = String(answers.current_address_city ?? '').trim()
    const state = String(answers.current_address_state ?? '').trim()
    const zip = String(answers.current_address_zip ?? '').trim()

    const cityStateZip = [city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')
    return [line1, cityStateZip].filter(Boolean).join(', ')
}

/** Display helper for InternationalAddress payloads (+ optional legacy component answers). */
export function formatInternationalAddressDisplay(
    address?: {
        formatted_address?: string
        address_line1?: string
        locality?: string
        administrative_area?: string
        postal_code?: string
        country_code?: string
    } | null,
    legacyAnswers?: Record<string, unknown>,
): string {
    if (address?.formatted_address?.trim()) {
        return address.formatted_address.trim()
    }
    if (address) {
        const regionPostal = [
            address.administrative_area,
            address.postal_code,
        ]
            .filter(Boolean)
            .join(' ')
        const line = [
            address.address_line1,
            [address.locality, regionPostal].filter(Boolean).join(', '),
            address.country_code,
        ]
            .filter(Boolean)
            .join(', ')
        if (line) return line
    }
    if (legacyAnswers) {
        return formatAddressDisplay(legacyAnswers)
    }
    return ''
}
